import gql from 'graphql-tag'
import { Broadcast } from '@dinosband/bv-messenger-schema'
import { ClientType } from '@dinosband/bv-apollo-client'

export function subscribeBroadcast (apollo: ClientType, chatRoomId: number, profileId: number) {
  return apollo.subscribe<{broadcasted: Broadcast}>({
    query: gql`subscription broadcasted($chatRoomId: Int!, $profileId: Int!) {
      broadcasted(chatRoomId: $chatRoomId, profileId: $profileId) {
        chatRoomId
        profileId
        props
        tokens
      }
    }`,
    variables: {
      chatRoomId,
      profileId,
    },
  })
}
